import { TreatmentPicker } from './TreatmentPicker';

export default TreatmentPicker;
